module.exports = __webpack_public_path__ + "img/Testimoni_Stefanus.6879b9a2.png";